import { Bar, BarChart, Tooltip,Legend, XAxis, YAxis } from "recharts"

const SLABarras = () => {
    const data = [
        {
          name: 'Enero 1',
          series3: 24,
          series2: 71,
          series1: 5,
        },
        {
          name: 'Enero 2',
          series3: 24,
          series2: 71,
          series1: 5,
        },
        {
          name: 'Enero 3',
          series3: 24,
          series2: 71,
          series1: 5,
        },
        {
          name: 'Enero 4',
          series3: 24,
          series2: 71,
          series1: 5,
        },
        {
          name: 'Enero 5',
          series3: 24,
          series2: 71,
          series1: 5,
        },
        {
          name: 'Enero 6',
          series3: 24,
          series2: 71,
          series1: 5,
        },
        {
          name: 'Enero 7',
          series3: 24,
          series2: 71,
          series1: 5,
        },
        {
          name: 'Enero 8',
          series3: 24,
          series2: 71,
          series1: 5,
        },
        {
          name: 'Enero 9',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 10',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 11',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 12',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 13',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 14',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 15',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 16',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 17',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 18',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 19',
          series3: 18,
          series2: 75,
          series1: 7,
        },
        {
          name: 'Enero 20',
          series3: 18,
          series2: 75,
          series1: 7,
        }
      ];


return(
    <div className="mt-2">
        <BarChart
          width={500}
          height={300}
          id="indicadores-graficos"
          data={data}
          margin={{
            top: 10,
            right: 30,
            left: 20,
            bottom: 10,
          }}
        >
          <XAxis dataKey="name" />
          <YAxis />
          <Legend/>
          <Tooltip />
          <Bar dataKey="series1" fill="#0088FE" stackId="a" animationDuration={1100} />
          <Bar dataKey="series2" fill="#FF8042" stackId="a" animationDuration={1100} />
          <Bar dataKey="series3" fill="#00C49F" stackId="a" animationDuration={1100} />
        </BarChart>
    </div>

)


}


export default SLABarras